import { gql } from '@urql/core';

const QueryTenantDashboardEmbedToken = gql`
  query TenantDashboardEmbedToken($input: GetTenantDashboardEmbedTokenRequest!) {
    tenantDashboardEmbedToken(input: $input) {
      token
      dashboardId
      supersetDomain
    }
  }
`;

export default QueryTenantDashboardEmbedToken;
